var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('player-link',{attrs:{"playerId":_vm.playerId,"label":"игрок"}}),_vm._v("\n  ("),_c('router-link',{attrs:{"to":{name: 'player_rushes', params: {playerId: _vm.playerId}}}},[_vm._v("ражи")]),_vm._v(")\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }